/**
 * TanStack Query hooks for `igaming-regulator-audit-extract-mga-ukgc-cura-ao-f`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingRegulatorAuditExtractMgaUkgcCuraAoFQueryKeys,
	type CreateIgamingRegulatorAuditExtractMgaUkgcCuraAoFBody,
	type ListIgamingRegulatorAuditExtractMgaUkgcCuraAoFResponse,
	type IgamingRegulatorAuditExtractMgaUkgcCuraAoFRow,
} from "./api";

export function useIgamingRegulatorAuditExtractMgaUkgcCuraAoFList(): UseQueryResult<ListIgamingRegulatorAuditExtractMgaUkgcCuraAoFResponse, Error> {
	return useQuery({
		queryKey: igamingRegulatorAuditExtractMgaUkgcCuraAoFQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingRegulatorAuditExtractMgaUkgcCuraAoFCreate(): UseMutationResult<IgamingRegulatorAuditExtractMgaUkgcCuraAoFRow, Error, CreateIgamingRegulatorAuditExtractMgaUkgcCuraAoFBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingRegulatorAuditExtractMgaUkgcCuraAoFQueryKeys.all });
		},
	});
}

export function useIgamingRegulatorAuditExtractMgaUkgcCuraAoFDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingRegulatorAuditExtractMgaUkgcCuraAoFQueryKeys.all });
		},
	});
}
